﻿<template>
    <wrapper>
        <div class="product">
            <b-row v-if="catalog">
                <b-col class="d-none d-lg-block" cols="3">
                    <product-filter v-if="!showAllProducts" @sendSelectedFilters="updateFilters" :pageFilter="pageFilter" />

                    <product-filter-categories v-if="categories && categories.length"
                                               :categories="categories"
                                               :showAllProducts="showAllProducts"
                                               :categoryId="parseInt(pageFilter.category_id)"
                                               @set-category="setCategory" />
                </b-col>

                <b-col cols="12" lg="9">
                    <product-list :filters="selectedFilters"
                                  :showSubCategoriesFilter="!showAllProducts"
                                  :catalog="catalog"
                                  :pageFilter="pageFilter"
                                  @update-list="setCategory" />
                </b-col>
            </b-row>
        </div>
    </wrapper>
</template>

<script>
    import Wrapper from "@/components/common/wrapper.vue";
    import ProductList from '@/components/views/category/product-list.vue';
    import ProductFilter from '@/components/views/category/product-filter.vue';
    import ProductFilterCategories from '@/components/views/category/product-filter-categories.vue';
    import { catalogService } from '@/services';
    import { CustomerConstant } from "@/constants/customer-constant";

    export default {
        components: {
            wrapper: Wrapper,
            'product-list': ProductList,
            'product-filter': ProductFilter,
            'product-filter-categories': ProductFilterCategories
        },

        data() {
            return {
                selectedFilters: [],
                catalog: null,
                categories: [],
                pageFilter: null,
                CustomerConstant
            }
        },

        props: {
            //The first part of URL after domain
            mainCategorySlug: {
                type: String
            },

            view: {
                type: String
            }
        },

        watch: {
            async "$route.path"() {
                await this.setCategory();
            }
        },

        async created() {
            await this.setCategory();
            await this.getCategoryFilter();
        },

        methods: {
            updateFilters(filters) {
                //Update filter via emit logic
                this.selectedFilters = filters;
            },

            async setCategory(body) {
                //If body is null need to set as empty object
                if (!body)
                    body = {};

                //Shows overlay during data loading
                this.$root.showOverlay();

                //If categoryId doest not exist it is means that we on the main category page otherwise we on the sub-category page
                let slug = this.$route.params.categoryId || this.mainCategorySlug;

                //Send request to get category filters
                this.pageFilter = await catalogService.getCategoryFilterBySlug(slug, body);

                if (this.pageFilter.published) {
                    //Send request to get category products
                    this.catalog = await catalogService.getCategoryProductsBySlug(slug, Object.keys(body).length ? body : {
                        page_number: 1,
                        page_size: this.pageFilter.page_size_options[0].value,
                        order_by: this.pageFilter.available_sort_options[0].value
                    });

                    //Shows overlay during data loading
                    this.$root.hideOverlay();
                }
                else {
                    this.$router.replace({ path: '/dc-power-distribution', query: { view: 'all' } });
                }
            },

            async getCategoryFilter() {
                //Send request to get available categories with subcategories
                this.categories = await catalogService.getHomePageCategories();
            }
        },

        computed: {
            showAllProducts() {
                return this.view === CustomerConstant.allProductsViewName;
            }
        }
    };
</script>